import { type MaterialCaseType } from "services/materialCases/materialCaseService";

export function parseMaterialTypeParam(
  param?: string,
): MaterialCaseType | null {
  const lower = param?.toLowerCase();
  if (lower === "mav") return "MAV";
  if (lower === "mst") return "MST";
  return null;
}
